var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 27,
    viewBox: "0 0 137 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8054 8.45178H34.4253V12.7716H36.7611C37.84 12.7716 38.9494 12.596 39.971 12.2792C40.473 12.1234 41.0365 11.9068 41.5316 11.6342C40.8794 10.8554 40.5464 9.87205 40.4486 8.90272C40.3153 7.58409 40.6062 5.86812 41.5817 4.83595L42.0674 4.32218L42.646 4.7478C44.103 5.81841 45.3283 7.31463 45.5443 9.02026C47.2987 8.54825 49.3585 8.65987 50.9049 9.47618L51.5393 9.81106L51.2054 10.4073C49.8975 12.742 47.1635 13.4651 44.4905 13.3373C40.4906 22.4499 31.7824 26.7643 21.2238 26.7643C15.7686 26.7643 10.764 24.899 7.91402 20.4721C7.74693 20.1971 7.60389 19.9095 7.45215 19.6269C6.48881 17.6783 6.16878 15.5435 6.38577 13.4106L6.45103 12.7717H10.4016V8.45178H15.0215V4.22589H24.2613V0H29.8054V8.45178Z",
    fill: "#A3A3A3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_12647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 44,
    height: 27
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3483 0.370483V8.89317H10.9053V13.1545H7.1854C7.16985 13.2779 7.15712 13.4015 7.144 13.5251C6.91155 15.8468 7.35322 17.988 8.36843 19.8187L8.70892 20.3803C8.91309 20.7169 9.15139 21.033 9.40323 21.3415C9.65445 21.6494 9.74352 21.8199 9.90164 22.0246C12.5856 24.7919 16.5862 26.1238 21.2049 26.1238C31.4333 26.1238 40.1142 21.9666 43.9559 12.6276C46.6816 12.8842 49.2963 12.243 50.4878 10.1089C48.5897 9.1042 46.1503 9.42621 44.7447 10.0743L48.4683 0.370483L33.9278 8.89317H29.2829V0.370483H15.3483Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_12647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0135 0.705811H29.0157V4.37779H25.0135V0.705811Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 4.0718V1.0116V4.0718ZM26.105 4.07161V1.0116V4.07161ZM26.7113 4.07161V1.0116V4.07161ZM27.3177 4.07161V1.0116V4.07161ZM27.9242 4.07161V1.0116V4.07161ZM28.5244 4.07161V1.0116V4.07161Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 4.0718V1.0116M26.105 4.07161V1.0116M26.7113 4.07161V1.0116M27.3177 4.07161V1.0116M27.9242 4.07161V1.0116M28.5244 4.07161V1.0116",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 4.37781H33.6335V0.706197H29.6313V4.37781Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 1.01207V4.07227V1.01207ZM30.7228 1.01225V4.07227V1.01225ZM31.3291 1.01225V4.07227V1.01225ZM31.9355 1.01225V4.07227V1.01225ZM32.542 1.01225V4.07227V1.01225ZM33.1422 1.01225V4.07227V1.01225Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 1.01207V4.07227M30.7228 1.01225V4.07227M31.3291 1.01225V4.07227M31.9355 1.01225V4.07227M32.542 1.01225V4.07227M33.1422 1.01225V4.07227",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54227 4.94263H10.5445V8.61424H6.54227V4.94263Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54227 9.17908H10.5445V12.8511H6.54227V9.17908Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03361 8.30849V5.24829V8.30849ZM7.63381 8.30831V5.24829V8.30831ZM8.24007 8.30831V5.24829V8.30831ZM8.84652 8.30831V5.24829V8.30831ZM9.45298 8.30831V5.24829V8.30831ZM10.0532 8.30831V5.24829V8.30831Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03361 8.30849V5.24829M7.63381 8.30831V5.24829M8.24007 8.30831V5.24829M8.84652 8.30831V5.24829M9.45298 8.30831V5.24829M10.0532 8.30831V5.24829",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03361 12.5448V9.48462V12.5448ZM7.63381 12.5446V9.48462V12.5446ZM8.24007 12.5446V9.48462V12.5446ZM8.84652 12.5446V9.48462V12.5446ZM9.45298 12.5446V9.48462V12.5446ZM10.0532 12.5446V9.48462V12.5446Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03361 12.5448V9.48462M7.63381 12.5446V9.48462M8.24007 12.5446V9.48462M8.84652 12.5446V9.48462M9.45298 12.5446V9.48462M10.0532 12.5446V9.48462",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.16 12.8507H15.1623V9.1791H11.16V12.8507Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1601 8.61426H15.1623V4.94228H11.1601V8.61426Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6514 9.48509V12.5453V9.48509ZM12.2516 9.48527V12.5453V9.48527ZM12.8579 9.48527V12.5453V9.48527ZM13.4643 9.48527V12.5453V9.48527ZM14.0708 9.48527V12.5453V9.48527ZM14.671 9.48527V12.5453V9.48527Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6514 9.48509V12.5453M12.2516 9.48527V12.5453M12.8579 9.48527V12.5453M13.4643 9.48527V12.5453M14.0708 9.48527V12.5453M14.671 9.48527V12.5453",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6514 5.24852V8.30872V5.24852ZM12.2516 5.2487V8.30872V5.2487ZM12.8579 5.2487V8.30872V5.2487ZM13.4643 5.2487V8.30872V5.2487ZM14.0708 5.2487V8.30872V5.2487ZM14.671 5.2487V8.30872V5.2487Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6514 5.24852V8.30872M12.2516 5.2487V8.30872M12.8579 5.2487V8.30872M13.4643 5.2487V8.30872M14.0708 5.2487V8.30872M14.671 5.2487V8.30872",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7779 4.94263H19.7801V8.61424H15.7779V4.94263Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 9.17908H19.7801V12.8511H15.7778V9.17908Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692 8.30849V5.24829V8.30849ZM16.8694 8.30831V5.24829V8.30831ZM17.4756 8.30831V5.24829V8.30831ZM18.0821 8.30831V5.24829V8.30831ZM18.6885 8.30831V5.24829V8.30831ZM19.2887 8.30831V5.24829V8.30831Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692 8.30849V5.24829M16.8694 8.30831V5.24829M17.4756 8.30831V5.24829M18.0821 8.30831V5.24829M18.6885 8.30831V5.24829M19.2887 8.30831V5.24829",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692 12.5448V9.48462V12.5448ZM16.8694 12.5446V9.48462V12.5446ZM17.4756 12.5446V9.48462V12.5446ZM18.0821 12.5446V9.48462V12.5446ZM18.6885 12.5446V9.48462V12.5446ZM19.2887 12.5446V9.48462V12.5446Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2692 12.5448V9.48462M16.8694 12.5446V9.48462M17.4756 12.5446V9.48462M18.0821 12.5446V9.48462M18.6885 12.5446V9.48462M19.2887 12.5446V9.48462",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3956 12.8507H24.3979V9.1791H20.3956V12.8507Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3957 8.61426H24.3979V4.94228H20.3957V8.61426Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.887 9.48509V12.5453V9.48509ZM21.4872 9.48527V12.5453V9.48527ZM22.0935 9.48527V12.5453V9.48527ZM22.6999 9.48527V12.5453V9.48527ZM23.3064 9.48527V12.5453V9.48527ZM23.9066 9.48527V12.5453V9.48527Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.887 9.48509V12.5453M21.4872 9.48527V12.5453M22.0935 9.48527V12.5453M22.6999 9.48527V12.5453M23.3064 9.48527V12.5453M23.9066 9.48527V12.5453",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.887 5.24852V8.30872V5.24852ZM21.4872 5.2487V8.30872V5.2487ZM22.0935 5.2487V8.30872V5.2487ZM22.6999 5.2487V8.30872V5.2487ZM23.3064 5.2487V8.30872V5.2487ZM23.9066 5.2487V8.30872V5.2487Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.887 5.24852V8.30872M21.4872 5.2487V8.30872M22.0935 5.2487V8.30872M22.6999 5.2487V8.30872M23.3064 5.2487V8.30872M23.9066 5.2487V8.30872",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0135 4.94263H29.0158V8.61424H25.0135V4.94263Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0135 9.17908H29.0158V12.8511H25.0135V9.17908Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 8.30849V5.24829V8.30849ZM26.105 8.30831V5.24829V8.30831ZM26.7113 8.30831V5.24829V8.30831ZM27.3177 8.30831V5.24829V8.30831ZM27.9242 8.30831V5.24829V8.30831ZM28.5244 8.30831V5.24829V8.30831Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 8.30849V5.24829M26.105 8.30831V5.24829M26.7113 8.30831V5.24829M27.3177 8.30831V5.24829M27.9242 8.30831V5.24829M28.5244 8.30831V5.24829",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 12.5448V9.48462V12.5448ZM26.105 12.5446V9.48462V12.5446ZM26.7113 12.5446V9.48462V12.5446ZM27.3177 12.5446V9.48462V12.5446ZM27.9242 12.5446V9.48462V12.5446ZM28.5244 12.5446V9.48462V12.5446Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5048 12.5448V9.48462M26.105 12.5446V9.48462M26.7113 12.5446V9.48462M27.3177 12.5446V9.48462M27.9242 12.5446V9.48462M28.5244 12.5446V9.48462",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 12.8507H33.6335V9.1791H29.6313V12.8507Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6313 8.61426H33.6336V4.94228H29.6313V8.61426Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 9.48509V12.5453V9.48509ZM30.7228 9.48527V12.5453V9.48527ZM31.3291 9.48527V12.5453V9.48527ZM31.9355 9.48527V12.5453V9.48527ZM32.542 9.48527V12.5453V9.48527ZM33.1422 9.48527V12.5453V9.48527Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 9.48509V12.5453M30.7228 9.48527V12.5453M31.3291 9.48527V12.5453M31.9355 9.48527V12.5453M32.542 9.48527V12.5453M33.1422 9.48527V12.5453",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 5.24852V8.30872V5.24852ZM30.7228 5.2487V8.30872V5.2487ZM31.3291 5.2487V8.30872V5.2487ZM31.9355 5.2487V8.30872V5.2487ZM32.542 5.2487V8.30872V5.2487ZM33.1422 5.2487V8.30872V5.2487Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1226 5.24852V8.30872M30.7228 5.2487V8.30872M31.3291 5.2487V8.30872M31.9355 5.2487V8.30872M32.542 5.2487V8.30872M33.1422 5.2487V8.30872",
    stroke: "#A3A3A3",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_134_12647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 44,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3483 0.370483V8.89317H10.9053V13.1545H7.1854C7.16985 13.2779 7.15712 13.4015 7.144 13.5251C6.91155 15.8468 7.35322 17.988 8.36843 19.8187L8.70892 20.3803C8.91309 20.7169 9.15139 21.033 9.40323 21.3415C9.65445 21.6494 9.74352 21.8199 9.90164 22.0246C12.5856 24.7919 16.5862 26.1238 21.2049 26.1238C31.4333 26.1238 40.1142 21.9666 43.9559 12.6276C46.6816 12.8842 49.2963 12.243 50.4878 10.1089C48.5897 9.1042 46.1503 9.42621 44.7447 10.0743L48.4683 0.370483L33.9278 8.89317H29.2829V0.370483H15.3483Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_134_12647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7463 10.0753C45.0559 7.86754 43.2551 6.13355 42.1383 5.31018C40.8513 6.67529 40.6514 10.253 42.6705 11.7593C41.5436 12.6775 39.1692 13.5097 36.738 13.5097H6.86633C6.63005 15.8381 6.86633 27.0503 6.86633 27.0503H50.6898L50.4904 10.1116C48.5925 9.10667 46.1517 9.42738 44.7463 10.0753Z",
    fill: "#A3A3A3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_134_12647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 44,
    height: 27
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3483 0.370483V8.89317H10.9053V13.1545H7.1854C7.16985 13.2779 7.15712 13.4015 7.144 13.5251C6.91155 15.8468 7.35322 17.988 8.36843 19.8187L8.70892 20.3803C8.91309 20.7169 9.15139 21.033 9.40323 21.3415C9.65445 21.6494 9.74352 21.8199 9.90164 22.0246C12.5856 24.7919 16.5862 26.1238 21.2049 26.1238C31.4333 26.1238 40.1142 21.9666 43.9559 12.6276C46.6816 12.8842 49.2963 12.243 50.4878 10.1089C48.5897 9.1042 46.1503 9.42621 44.7447 10.0743L48.4683 0.370483L33.9278 8.89317H29.2829V0.370483H15.3483Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_134_12647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8663 16.4895V27.0502H50.6897V16.4895",
    fill: "#A3A3A3",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_134_12647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 44,
    height: 27
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3483 0.370483V8.89317H10.9053V13.1545H7.1854C7.16985 13.2779 7.15712 13.4015 7.144 13.5251C6.91155 15.8468 7.35322 17.988 8.36843 19.8187L8.70892 20.3803C8.91309 20.7169 9.15139 21.033 9.40323 21.3415C9.65445 21.6494 9.74352 21.8199 9.90164 22.0246C12.5856 24.7919 16.5862 26.1238 21.2049 26.1238C31.4333 26.1238 40.1142 21.9666 43.9559 12.6276C46.6816 12.8842 49.2963 12.243 50.4878 10.1089C48.5897 9.1042 46.1503 9.42621 44.7447 10.0743L48.4683 0.370483L33.9278 8.89317H29.2829V0.370483H15.3483Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_134_12647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4645 26.1035C19.73 24.9131 18.2293 23.2947 17.3943 21.5283L9.08781 21.8626L13.3288 27.0503L22.4645 26.1035Z",
    fill: "#A3A3A3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_134_12647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 44,
    height: 27
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3483 0.370483V8.89317H10.9053V13.1545H7.1854C7.16985 13.2779 7.15712 13.4015 7.144 13.5251C6.91155 15.8468 7.35322 17.988 8.36843 19.8187L8.70892 20.3803C8.91309 20.7169 9.15139 21.033 9.40323 21.3415C9.65445 21.6494 9.74352 21.8199 9.90164 22.0246C12.5856 24.7919 16.5862 26.1238 21.2049 26.1238C31.4333 26.1238 40.1142 21.9666 43.9559 12.6276C46.6816 12.8842 49.2963 12.243 50.4878 10.1089C48.5897 9.1042 46.1503 9.42621 44.7447 10.0743L48.4683 0.370483L33.9278 8.89317H29.2829V0.370483H15.3483Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_134_12647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9341 9.99341V9.99897C40.7212 14.981 34.6784 19.3332 28.1911 21.6195C22.4042 23.6588 17.3587 23.6686 13.8779 22.0304C13.503 21.8362 13.1355 21.6208 12.7671 21.4168C10.2151 19.7804 8.77757 17.0735 8.89834 13.5077H6.8663V27.0503H50.6897V9.26379H45.641L44.9341 9.99341Z",
    fill: "#A3A3A3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23818 21.8049C11.9951 21.8997 14.9373 21.9167 17.5039 21.4114",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4212 19.8352C20.4229 19.9829 20.399 20.1295 20.351 20.2666C20.3029 20.4036 20.2315 20.5283 20.1411 20.6335C20.0506 20.7386 19.9428 20.8221 19.824 20.8791C19.7051 20.9361 19.5776 20.9655 19.4488 20.9655C19.32 20.9655 19.1925 20.9361 19.0736 20.8791C18.9548 20.8221 18.847 20.7386 18.7566 20.6335C18.6661 20.5283 18.5947 20.4036 18.5467 20.2666C18.4986 20.1295 18.4747 19.9829 18.4765 19.8352C18.4799 19.5421 18.5839 19.2623 18.7659 19.0564C18.9478 18.8505 19.1932 18.7351 19.4488 18.7351C19.7044 18.7351 19.9498 18.8505 20.1318 19.0564C20.3137 19.2623 20.4177 19.5421 20.4212 19.8352Z",
    fill: "#A3A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6966 19.1164C19.6356 19.149 19.5879 19.1994 19.5609 19.2596C19.5339 19.3198 19.5292 19.3865 19.5475 19.4495C19.5657 19.5124 19.6059 19.5681 19.6618 19.6078C19.7177 19.6475 19.7863 19.6691 19.8568 19.6692C19.9783 19.6692 20.0836 19.6069 20.1383 19.5151C20.2076 19.6696 20.2171 19.8415 20.1651 20.0018C20.1131 20.162 20.0028 20.3007 19.8528 20.3945C19.7029 20.4883 19.5225 20.5313 19.3421 20.5164C19.1618 20.5014 18.9925 20.4294 18.863 20.3125C18.7335 20.1956 18.6517 20.0409 18.6314 19.8747C18.6111 19.7085 18.6535 19.5409 18.7515 19.4002C18.8496 19.2596 18.9972 19.1545 19.1694 19.1028C19.3416 19.0511 19.5278 19.0559 19.6966 19.1164ZM0 16.6787H51.0531C49.9416 16.4181 47.5362 16.0663 47.9329 14.7203C45.9114 16.8812 41.0369 16.2362 39.8066 15.1708C38.4367 17.0064 30.4614 16.3087 29.9052 14.8787C28.1876 16.7406 22.8659 16.7406 21.1484 14.8787C20.5917 16.3085 12.6166 17.0064 11.2466 15.1708C10.0164 16.2362 5.14211 16.8812 3.12067 14.7203C3.51733 16.0663 1.11189 16.4181 0 16.6787Z",
    fill: "#A3A3A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.458 21.3457L107.45 16.4214M107.45 16.4214L107.424 7.62403M107.45 16.4214L112.633 11.4154M107.45 16.4214L112.658 21.3621M77.94 16.4865C77.9652 15.4307 77.6441 14.3515 76.9941 13.478C76.0569 12.2196 74.5405 11.3605 72.877 11.342C72.7662 11.342 72.6562 11.342 72.5446 11.3501C71.8869 11.389 71.2499 11.4763 70.6863 11.7008C66.9797 13.1759 66.323 18.0991 69.4502 20.3267C72.1586 22.2556 76.0982 21.4681 77.4628 18.5249C77.7511 17.9029 77.9402 17.1187 77.9402 16.4865V7.58337M102.95 11.9289C102.182 11.4547 101.287 11.2834 100.401 11.285C100.305 11.285 100.206 11.2894 100.12 11.293C97.5588 11.3984 95.1844 13.1293 95.1844 16.4865C95.1844 20.4558 99.6338 22.598 102.958 20.7263M117.892 20.2941C120.511 18.148 125.76 13.8451 125.76 13.8451C125.76 13.8451 125.568 13.4987 125.444 13.3395C124.385 11.9799 122.767 11.3011 121.063 11.3011C116.851 11.3011 113.694 16.5106 117.892 20.2941ZM117.892 20.2941C118.183 20.5561 118.582 20.7612 119.026 20.9382C120.566 21.5525 122.675 21.5022 123.816 20.6935M135.041 11.4154C133.748 11.4187 132.489 11.8518 131.555 12.6871C130.083 13.8493 129.763 15.3168 129.782 17.1715L129.825 21.3866M86.5487 11.3175C86.4292 11.3194 86.3106 11.3316 86.1907 11.3337C82.9969 11.39 80.6942 14.563 81.3918 17.5056C82.0716 20.3733 85.3469 22.0714 88.1768 21.1338C91.4722 20.3074 92.816 16.3384 91.0066 13.6574C90.0172 12.1911 88.3397 11.285 86.5487 11.3175Z",
    stroke: "#A3A3A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.66302238f77f1f003087c7536f4bd7f9.svg";
export { ForwardRef as ReactComponent };